import { BaseElement, defineElement } from '@webtides/element-js';
import AccordionRegisterStore from '../../stores/accordion-register-store.js';

export default class AccordionGroup extends BaseElement {
    properties() {
        return {
            showMultiple: true,
            accordionRegisterStore: new AccordionRegisterStore(),
        };
    }

    provideProperties() {
        return {
            accordionRegisterStore: this.accordionRegisterStore,
        };
    }

    events() {
        return {
            this: {
                // TODO: [AccordionToggleEvent.name] is not working with JSDoc...
                /** @param {AccordionToggleEvent} event */
                'mb-accordion-toggle': (event) => {
                    if (this.showMultiple) return;

                    for (const item of this.accordionRegisterStore.items) {
                        if (item === event.item) continue;
                        item.open = false;
                    }
                },
            },
        };
    }
}

defineElement('mb-accordion-group', AccordionGroup);
